import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { newMessage } from './newMessage';
import { face } from './face';
import { interactionMode } from './interactionMode';
import { requestInteractionMode } from './requestInteractionMode';
import { endConversation } from './endConversationAction';

export const inputActions = [
  newMessage,
  face,
  interactionMode,
  requestInteractionMode,
  endConversation,
];

export type InputActions = ActionsOfCreators<typeof inputActions>;

export type InputHandler<T extends InputActions> = FeatureHandler<
  T,
  InputActions
>;
